(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './Grade', './Metadata', './UrlInfo'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Grade'), require('./Metadata'), require('./UrlInfo'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.Metadata = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Grade, root.SmartCsV2Sdk.Metadata, root.SmartCsV2Sdk.UrlInfo);
  }
}(this, function(ApiClient, Grade, Metadata, UrlInfo) {
  'use strict';

  /**
   * The Metadata model module.
   * @module model/Metadata
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>Metadata</code>.
   * @alias module:model/Metadata
   * @class
   */
  var exports = function() {



















































  };

  /**
   * Constructs a <code>Metadata</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Metadata} obj Optional instance to populate.
   * @return {module:model/Metadata} The populated <code>Metadata</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('tags')) {
        obj['tags'] = ApiClient.convertToType(data['tags'], ['String']);
      }
      if (data.hasOwnProperty('ancestors')) {
        obj['ancestors'] = ApiClient.convertToType(data['ancestors'], ['String']);
      }
      if (data.hasOwnProperty('author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (data.hasOwnProperty('brandLogo')) {
        obj['brandLogo'] = ApiClient.convertToType(data['brandLogo'], 'String');
      }
      if (data.hasOwnProperty('category')) {
        obj['category'] = ApiClient.convertToType(data['category'], 'String');
      }
      if (data.hasOwnProperty('children')) {
        obj['children'] = ApiClient.convertToType(data['children'], [Metadata]);
      }
      if (data.hasOwnProperty('childrenIds')) {
        obj['childrenIds'] = ApiClient.convertToType(data['childrenIds'], ['String']);
      }
      if (data.hasOwnProperty('clientPlatform')) {
        obj['clientPlatform'] = ApiClient.convertToType(data['clientPlatform'], 'String');
      }
      if (data.hasOwnProperty('componentType')) {
        obj['componentType'] = ApiClient.convertToType(data['componentType'], 'String');
      }
      if (data.hasOwnProperty('componentTypes')) {
        obj['componentTypes'] = ApiClient.convertToType(data['componentTypes'], ['String']);
      }
      if (data.hasOwnProperty('country')) {
        obj['country'] = ApiClient.convertToType(data['country'], 'String');
      }
      if (data.hasOwnProperty('createdDate')) {
        obj['createdDate'] = ApiClient.convertToType(data['createdDate'], 'Integer');
      }
      if (data.hasOwnProperty('defaultPreviewUrl')) {
        obj['defaultPreviewUrl'] = UrlInfo.constructFromObject(data['defaultPreviewUrl']);
      }
      if (data.hasOwnProperty('defaultThumbnail')) {
        obj['defaultThumbnail'] = UrlInfo.constructFromObject(data['defaultThumbnail']);
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('expiry')) {
        obj['expiry'] = ApiClient.convertToType(data['expiry'], 'Integer');
      }
      if (data.hasOwnProperty('ext')) {
        obj['ext'] = ApiClient.convertToType(data['ext'], Object);
      }
      if (data.hasOwnProperty('externalId')) {
        obj['externalId'] = ApiClient.convertToType(data['externalId'], 'String');
      }
      if (data.hasOwnProperty('externalUrl')) {
        obj['externalUrl'] = ApiClient.convertToType(data['externalUrl'], 'String');
      }
      if (data.hasOwnProperty('fileName')) {
        obj['fileName'] = ApiClient.convertToType(data['fileName'], 'String');
      }
      if (data.hasOwnProperty('googleDriveId')) {
        obj['googleDriveId'] = ApiClient.convertToType(data['googleDriveId'], 'String');
      }
      if (data.hasOwnProperty('grades')) {
        obj['grades'] = ApiClient.convertToType(data['grades'], [Grade]);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('language')) {
        obj['language'] = ApiClient.convertToType(data['language'], 'String');
      }
      if (data.hasOwnProperty('lessonPersistDoc')) {
        obj['lessonPersistDoc'] = UrlInfo.constructFromObject(data['lessonPersistDoc']);
      }
      if (data.hasOwnProperty('locale')) {
        obj['locale'] = ApiClient.convertToType(data['locale'], 'String');
      }
      if (data.hasOwnProperty('lppLastModifiedDate')) {
        obj['lppLastModifiedDate'] = ApiClient.convertToType(data['lppLastModifiedDate'], 'Integer');
      }
      if (data.hasOwnProperty('modifiedBy')) {
        obj['modifiedBy'] = ApiClient.convertToType(data['modifiedBy'], 'String');
      }
      if (data.hasOwnProperty('modifiedDate')) {
        obj['modifiedDate'] = ApiClient.convertToType(data['modifiedDate'], 'Integer');
      }
      if (data.hasOwnProperty('nonRecoverableProcessingErrors')) {
        obj['nonRecoverableProcessingErrors'] = ApiClient.convertToType(data['nonRecoverableProcessingErrors'], ['String']);
      }
      if (data.hasOwnProperty('notebookLastGeneratedTime')) {
        obj['notebookLastGeneratedTime'] = ApiClient.convertToType(data['notebookLastGeneratedTime'], 'Integer');
      }
      if (data.hasOwnProperty('notebookUrl')) {
        obj['notebookUrl'] = UrlInfo.constructFromObject(data['notebookUrl']);
      }
      if (data.hasOwnProperty('parentId')) {
        obj['parentId'] = ApiClient.convertToType(data['parentId'], 'String');
      }
      if (data.hasOwnProperty('position')) {
        obj['position'] = ApiClient.convertToType(data['position'], 'Integer');
      }
      if (data.hasOwnProperty('previewList')) {
        obj['previewList'] = ApiClient.convertToType(data['previewList'], [UrlInfo]);
      }
      if (data.hasOwnProperty('processedResourceUrl')) {
        obj['processedResourceUrl'] = UrlInfo.constructFromObject(data['processedResourceUrl']);
      }
      if (data.hasOwnProperty('rawResourceUrl')) {
        obj['rawResourceUrl'] = UrlInfo.constructFromObject(data['rawResourceUrl']);
      }
      if (data.hasOwnProperty('recoverableProcessingErrors')) {
        obj['recoverableProcessingErrors'] = ApiClient.convertToType(data['recoverableProcessingErrors'], ['String']);
      }
      if (data.hasOwnProperty('resourceType')) {
        obj['resourceType'] = ApiClient.convertToType(data['resourceType'], 'String');
      }
      if (data.hasOwnProperty('source')) {
        obj['source'] = ApiClient.convertToType(data['source'], 'String');
      }
      if (data.hasOwnProperty('sso')) {
        obj['sso'] = ApiClient.convertToType(data['sso'], 'String');
      }
      if (data.hasOwnProperty('standardSets')) {
        obj['standardSets'] = ApiClient.convertToType(data['standardSets'], ['String']);
      }
      if (data.hasOwnProperty('standardStrands')) {
        obj['standardStrands'] = ApiClient.convertToType(data['standardStrands'], ['String']);
      }
      if (data.hasOwnProperty('subjects')) {
        obj['subjects'] = ApiClient.convertToType(data['subjects'], ['String']);
      }
      if (data.hasOwnProperty('subtype')) {
        obj['subtype'] = ApiClient.convertToType(data['subtype'], 'String');
      }
      if (data.hasOwnProperty('text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (data.hasOwnProperty('uploadedBy')) {
        obj['uploadedBy'] = ApiClient.convertToType(data['uploadedBy'], 'String');
      }
      if (data.hasOwnProperty('uploadedDate')) {
        obj['uploadedDate'] = ApiClient.convertToType(data['uploadedDate'], 'Integer');
      }
    }
    return obj;
  }


  /**
   * a set of tags (keywords) to aid in searching.
   * @member {Array.<String>} tags
   */
  exports.prototype['tags'] = undefined;

  /**
   * @member {Array.<String>} ancestors
   */
  exports.prototype['ancestors'] = undefined;

  /**
   * the legal author of this content.  This is typically a free form name (unicode characters OK).
   * @member {String} author
   */
  exports.prototype['author'] = undefined;

  /**
   * A URL that references the publishers logo.
   * @member {String} brandLogo
   */
  exports.prototype['brandLogo'] = undefined;

  /**
   * @member {module:model/Metadata.CategoryEnum} category
   */
  exports.prototype['category'] = undefined;

  /**
   * @member {Array.<module:model/Metadata>} children
   */
  exports.prototype['children'] = undefined;

  /**
   * @member {Array.<String>} childrenIds
   */
  exports.prototype['childrenIds'] = undefined;

  /**
   * @member {module:model/Metadata.ClientPlatformEnum} clientPlatform
   */
  exports.prototype['clientPlatform'] = undefined;

  /**
   * This will only be set if it's a child node
   * @member {module:model/Metadata.ComponentTypeEnum} componentType
   */
  exports.prototype['componentType'] = undefined;

  /**
   * @member {Array.<module:model/Metadata.ComponentTypesEnum>} componentTypes
   */
  exports.prototype['componentTypes'] = undefined;

  /**
   * @member {module:model/Metadata.CountryEnum} country
   */
  exports.prototype['country'] = undefined;

  /**
   * Currently used by PDFProcessor - the date of creation of the PDF
   * @member {Integer} createdDate
   */
  exports.prototype['createdDate'] = undefined;

  /**
   * The main preview that best represents the content.  This should be sized about 1024 px wide.
   * @member {module:model/UrlInfo} defaultPreviewUrl
   */
  exports.prototype['defaultPreviewUrl'] = undefined;

  /**
   * The default thumbnail for this resource.  Replaces the \"thumbnail\" attribute from the V1 content API. Expect that this image has been sampled\n down to a lower resolution TODO - what width do we expect here?
   * @member {module:model/UrlInfo} defaultThumbnail
   */
  exports.prototype['defaultThumbnail'] = undefined;

  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;

  /**
   * @member {Integer} expiry
   */
  exports.prototype['expiry'] = undefined;

  /**
   * @member {Object} ext
   */
  exports.prototype['ext'] = undefined;

  /**
   * An external identifier.  Has no implicit meaning to the content service but is here to facilitate integrations with third parties.
   * @member {String} externalId
   */
  exports.prototype['externalId'] = undefined;

  /**
   * The external url of the resource.  This implies the resource is hosted externally.
   * @member {String} externalUrl
   */
  exports.prototype['externalUrl'] = undefined;

  /**
   * @member {String} fileName
   */
  exports.prototype['fileName'] = undefined;

  /**
   * @member {String} googleDriveId
   */
  exports.prototype['googleDriveId'] = undefined;

  /**
   * @member {Array.<module:model/Grade>} grades
   */
  exports.prototype['grades'] = undefined;

  /**
   * the unique id of the resource.
   * @member {String} id
   */
  exports.prototype['id'] = undefined;

  /**
   * @member {module:model/Metadata.LanguageEnum} language
   */
  exports.prototype['language'] = undefined;

  /**
   * @member {module:model/UrlInfo} lessonPersistDoc
   */
  exports.prototype['lessonPersistDoc'] = undefined;

  /**
   * @member {String} locale
   */
  exports.prototype['locale'] = undefined;

  /**
   * @member {Integer} lppLastModifiedDate
   */
  exports.prototype['lppLastModifiedDate'] = undefined;

  /**
   * the Id of the user who last modified the resource.
   * @member {String} modifiedBy
   */
  exports.prototype['modifiedBy'] = undefined;

  /**
   * the Date this resource was last modified.
   * @member {Integer} modifiedDate
   */
  exports.prototype['modifiedDate'] = undefined;

  /**
   * @member {Array.<module:model/Metadata.NonRecoverableProcessingErrorsEnum>} nonRecoverableProcessingErrors
   */
  exports.prototype['nonRecoverableProcessingErrors'] = undefined;

  /**
   * @member {Integer} notebookLastGeneratedTime
   */
  exports.prototype['notebookLastGeneratedTime'] = undefined;

  /**
   * the reference url for the uploaded (processed) resource.
   * @member {module:model/UrlInfo} notebookUrl
   */
  exports.prototype['notebookUrl'] = undefined;

  /**
   * @member {String} parentId
   */
  exports.prototype['parentId'] = undefined;

  /**
   * @member {Integer} position
   */
  exports.prototype['position'] = undefined;

  /**
   * Will map to urlInfo in ModelContent which is currently being used. A use-case is to store previews of images of different sizes
   * @member {Array.<module:model/UrlInfo>} previewList
   */
  exports.prototype['previewList'] = undefined;

  /**
   * the reference url for the uploaded (processed) resource.
   * @member {module:model/UrlInfo} processedResourceUrl
   */
  exports.prototype['processedResourceUrl'] = undefined;

  /**
   * the reference url for the uploaded (unprocessed) resource.
   * @member {module:model/UrlInfo} rawResourceUrl
   */
  exports.prototype['rawResourceUrl'] = undefined;

  /**
   * @member {Array.<module:model/Metadata.RecoverableProcessingErrorsEnum>} recoverableProcessingErrors
   */
  exports.prototype['recoverableProcessingErrors'] = undefined;

  /**
   * @member {module:model/Metadata.ResourceTypeEnum} resourceType
   */
  exports.prototype['resourceType'] = undefined;

  /**
   * @member {String} source
   */
  exports.prototype['source'] = undefined;

  /**
   * SSO scheme to use.
   * @member {module:model/Metadata.SsoEnum} sso
   */
  exports.prototype['sso'] = undefined;

  /**
   * @member {Array.<String>} standardSets
   */
  exports.prototype['standardSets'] = undefined;

  /**
   * @member {Array.<String>} standardStrands
   */
  exports.prototype['standardStrands'] = undefined;

  /**
   * @member {Array.<String>} subjects
   */
  exports.prototype['subjects'] = undefined;

  /**
   * @member {String} subtype
   */
  exports.prototype['subtype'] = undefined;

  /**
   * @member {String} text
   */
  exports.prototype['text'] = undefined;

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;

  /**
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;

  /**
   * the Id of the user who uploaded this resource.
   * @member {String} uploadedBy
   */
  exports.prototype['uploadedBy'] = undefined;

  /**
   * @member {Integer} uploadedDate
   */
  exports.prototype['uploadedDate'] = undefined;


  /**
   * Allowed values for the <code>category</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CategoryEnum = { 
    /**
     * value: MATH
     * @const
     */
    MATH: "MATH",
    
    /**
     * value: ART
     * @const
     */
    ART: "ART",
    
    /**
     * value: SCIENCE
     * @const
     */
    SCIENCE: "SCIENCE"
  };  /**
   * Allowed values for the <code>clientPlatform</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ClientPlatformEnum = { 
    /**
     * value: SLO
     * @const
     */
    SLO: "SLO",
    
    /**
     * value: CP
     * @const
     */
    CP: "CP",
    
    /**
     * value: AMP
     * @const
     */
    AMP: "AMP",
    
    /**
     * value: AMP_WS
     * @const
     */
    AMP_WS: "AMP_WS"
  };  /**
   * Allowed values for the <code>componentType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComponentTypeEnum = { 
    /**
     * value: LESSON
     * @const
     */
    LESSON: "LESSON",
    
    /**
     * value: ACTIVITY
     * @const
     */
    ACTIVITY: "ACTIVITY",
    
    /**
     * value: ASSESSMENT
     * @const
     */
    ASSESSMENT: "ASSESSMENT",
    
    /**
     * value: TEMPLATE
     * @const
     */
    TEMPLATE: "TEMPLATE",
    
    /**
     * value: CLASSROOM_TOOLS
     * @const
     */
    CLASSROOM_TOOLS: "CLASSROOM_TOOLS",
    
    /**
     * value: CONTENT_LIST
     * @const
     */
    CONTENT_LIST: "CONTENT_LIST",
    
    /**
     * value: RESOURCE
     * @const
     */
    RESOURCE: "RESOURCE"
  };
  /**
   * Allowed values for the <code>componentTypes</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComponentTypesEnum = { 
    /**
     * value: LESSON
     * @const
     */
    LESSON: "LESSON",
    
    /**
     * value: ACTIVITY
     * @const
     */
    ACTIVITY: "ACTIVITY",
    
    /**
     * value: ASSESSMENT
     * @const
     */
    ASSESSMENT: "ASSESSMENT",
    
    /**
     * value: TEMPLATE
     * @const
     */
    TEMPLATE: "TEMPLATE",
    
    /**
     * value: CLASSROOM_TOOLS
     * @const
     */
    CLASSROOM_TOOLS: "CLASSROOM_TOOLS",
    
    /**
     * value: CONTENT_LIST
     * @const
     */
    CONTENT_LIST: "CONTENT_LIST",
    
    /**
     * value: RESOURCE
     * @const
     */
    RESOURCE: "RESOURCE"
  };  /**
   * Allowed values for the <code>country</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CountryEnum = { 
    /**
     * value: ALGERIA
     * @const
     */
    ALGERIA: "ALGERIA",
    
    /**
     * value: ARGENTINA
     * @const
     */
    ARGENTINA: "ARGENTINA",
    
    /**
     * value: AUSTRALIA
     * @const
     */
    AUSTRALIA: "AUSTRALIA",
    
    /**
     * value: AUSTRIA
     * @const
     */
    AUSTRIA: "AUSTRIA",
    
    /**
     * value: BANGLADESH
     * @const
     */
    BANGLADESH: "BANGLADESH",
    
    /**
     * value: BELGIUM
     * @const
     */
    BELGIUM: "BELGIUM",
    
    /**
     * value: BRAZIL
     * @const
     */
    BRAZIL: "BRAZIL",
    
    /**
     * value: CANADA
     * @const
     */
    CANADA: "CANADA",
    
    /**
     * value: CHILE
     * @const
     */
    CHILE: "CHILE",
    
    /**
     * value: CHINA
     * @const
     */
    CHINA: "CHINA",
    
    /**
     * value: COLOMBIA
     * @const
     */
    COLOMBIA: "COLOMBIA",
    
    /**
     * value: CYPRUS
     * @const
     */
    CYPRUS: "CYPRUS",
    
    /**
     * value: CZECH_REPUBLIC
     * @const
     */
    CZECH_REPUBLIC: "CZECH_REPUBLIC",
    
    /**
     * value: DOMINICAN_REPUBLIC
     * @const
     */
    DOMINICAN_REPUBLIC: "DOMINICAN_REPUBLIC",
    
    /**
     * value: ECUADOR
     * @const
     */
    ECUADOR: "ECUADOR",
    
    /**
     * value: EGYPT
     * @const
     */
    EGYPT: "EGYPT",
    
    /**
     * value: ENGLAND
     * @const
     */
    ENGLAND: "ENGLAND",
    
    /**
     * value: ETHIOPIA
     * @const
     */
    ETHIOPIA: "ETHIOPIA",
    
    /**
     * value: DENMARK
     * @const
     */
    DENMARK: "DENMARK",
    
    /**
     * value: FRANCE
     * @const
     */
    FRANCE: "FRANCE",
    
    /**
     * value: FINLAND
     * @const
     */
    FINLAND: "FINLAND",
    
    /**
     * value: GERMANY
     * @const
     */
    GERMANY: "GERMANY",
    
    /**
     * value: GREECE
     * @const
     */
    GREECE: "GREECE",
    
    /**
     * value: HONG_KONG
     * @const
     */
    HONG_KONG: "HONG_KONG",
    
    /**
     * value: HUNGARY
     * @const
     */
    HUNGARY: "HUNGARY",
    
    /**
     * value: INDIA
     * @const
     */
    INDIA: "INDIA",
    
    /**
     * value: INDONESIA
     * @const
     */
    INDONESIA: "INDONESIA",
    
    /**
     * value: IRAN
     * @const
     */
    IRAN: "IRAN",
    
    /**
     * value: IRAQ
     * @const
     */
    IRAQ: "IRAQ",
    
    /**
     * value: IRELAND
     * @const
     */
    IRELAND: "IRELAND",
    
    /**
     * value: ISRAEL
     * @const
     */
    ISRAEL: "ISRAEL",
    
    /**
     * value: ITALY
     * @const
     */
    ITALY: "ITALY",
    
    /**
     * value: JAPAN
     * @const
     */
    JAPAN: "JAPAN",
    
    /**
     * value: KAZAKHSTAN
     * @const
     */
    KAZAKHSTAN: "KAZAKHSTAN",
    
    /**
     * value: KOREA_REPUBLIC_OF
     * @const
     */
    KOREA_REPUBLIC_OF: "KOREA_REPUBLIC_OF",
    
    /**
     * value: LATVIA
     * @const
     */
    LATVIA: "LATVIA",
    
    /**
     * value: LITHUANIA
     * @const
     */
    LITHUANIA: "LITHUANIA",
    
    /**
     * value: MALAYSIA
     * @const
     */
    MALAYSIA: "MALAYSIA",
    
    /**
     * value: MEXICO
     * @const
     */
    MEXICO: "MEXICO",
    
    /**
     * value: MOROCCO
     * @const
     */
    MOROCCO: "MOROCCO",
    
    /**
     * value: MYANMAR
     * @const
     */
    MYANMAR: "MYANMAR",
    
    /**
     * value: NETHERLANDS
     * @const
     */
    NETHERLANDS: "NETHERLANDS",
    
    /**
     * value: NIGERIA
     * @const
     */
    NIGERIA: "NIGERIA",
    
    /**
     * value: NORTHERN_IRELAND
     * @const
     */
    NORTHERN_IRELAND: "NORTHERN_IRELAND",
    
    /**
     * value: NORWAY
     * @const
     */
    NORWAY: "NORWAY",
    
    /**
     * value: PAKISTAN
     * @const
     */
    PAKISTAN: "PAKISTAN",
    
    /**
     * value: PANAMA
     * @const
     */
    PANAMA: "PANAMA",
    
    /**
     * value: PERU
     * @const
     */
    PERU: "PERU",
    
    /**
     * value: PHILIPPINES
     * @const
     */
    PHILIPPINES: "PHILIPPINES",
    
    /**
     * value: POLAND
     * @const
     */
    POLAND: "POLAND",
    
    /**
     * value: PORTUGAL
     * @const
     */
    PORTUGAL: "PORTUGAL",
    
    /**
     * value: PUERTO_RICO
     * @const
     */
    PUERTO_RICO: "PUERTO_RICO",
    
    /**
     * value: ROMANIA
     * @const
     */
    ROMANIA: "ROMANIA",
    
    /**
     * value: RUSSIA
     * @const
     */
    RUSSIA: "RUSSIA",
    
    /**
     * value: SAUDI_ARABIA
     * @const
     */
    SAUDI_ARABIA: "SAUDI_ARABIA",
    
    /**
     * value: SCOTLAND
     * @const
     */
    SCOTLAND: "SCOTLAND",
    
    /**
     * value: SENEGAL
     * @const
     */
    SENEGAL: "SENEGAL",
    
    /**
     * value: SINGAPORE
     * @const
     */
    SINGAPORE: "SINGAPORE",
    
    /**
     * value: SLOVAKIA
     * @const
     */
    SLOVAKIA: "SLOVAKIA",
    
    /**
     * value: SLOVENIA
     * @const
     */
    SLOVENIA: "SLOVENIA",
    
    /**
     * value: SOUTH_AFRICA
     * @const
     */
    SOUTH_AFRICA: "SOUTH_AFRICA",
    
    /**
     * value: SPAIN
     * @const
     */
    SPAIN: "SPAIN",
    
    /**
     * value: SUDAN
     * @const
     */
    SUDAN: "SUDAN",
    
    /**
     * value: SWEDEN
     * @const
     */
    SWEDEN: "SWEDEN",
    
    /**
     * value: SWITZERLAND
     * @const
     */
    SWITZERLAND: "SWITZERLAND",
    
    /**
     * value: TAIWAN
     * @const
     */
    TAIWAN: "TAIWAN",
    
    /**
     * value: THAILAND
     * @const
     */
    THAILAND: "THAILAND",
    
    /**
     * value: TUNISIA
     * @const
     */
    TUNISIA: "TUNISIA",
    
    /**
     * value: TURKEY
     * @const
     */
    TURKEY: "TURKEY",
    
    /**
     * value: UKRAINE
     * @const
     */
    UKRAINE: "UKRAINE",
    
    /**
     * value: UNITED_ARAB_EMIRATES
     * @const
     */
    UNITED_ARAB_EMIRATES: "UNITED_ARAB_EMIRATES",
    
    /**
     * value: UNITED_STATES
     * @const
     */
    UNITED_STATES: "UNITED_STATES",
    
    /**
     * value: UZBEKISTAN
     * @const
     */
    UZBEKISTAN: "UZBEKISTAN",
    
    /**
     * value: VENEZUELA
     * @const
     */
    VENEZUELA: "VENEZUELA",
    
    /**
     * value: VIETNAM
     * @const
     */
    VIETNAM: "VIETNAM",
    
    /**
     * value: WALES
     * @const
     */
    WALES: "WALES"
  };  /**
   * Allowed values for the <code>language</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LanguageEnum = { 
    /**
     * value: AZERBAIJANI
     * @const
     */
    AZERBAIJANI: "AZERBAIJANI",
    
    /**
     * value: BENGALI
     * @const
     */
    BENGALI: "BENGALI",
    
    /**
     * value: BULGARIAN
     * @const
     */
    BULGARIAN: "BULGARIAN",
    
    /**
     * value: CATALAN
     * @const
     */
    CATALAN: "CATALAN",
    
    /**
     * value: CHINESE_SIMPLIFIED
     * @const
     */
    CHINESE_SIMPLIFIED: "CHINESE_SIMPLIFIED",
    
    /**
     * value: CHINESE_TRADITIONAL
     * @const
     */
    CHINESE_TRADITIONAL: "CHINESE_TRADITIONAL",
    
    /**
     * value: CROATIAN
     * @const
     */
    CROATIAN: "CROATIAN",
    
    /**
     * value: CZECH
     * @const
     */
    CZECH: "CZECH",
    
    /**
     * value: DANISH
     * @const
     */
    DANISH: "DANISH",
    
    /**
     * value: DUTCH
     * @const
     */
    DUTCH: "DUTCH",
    
    /**
     * value: EGYPTIAN_ARABIC
     * @const
     */
    EGYPTIAN_ARABIC: "EGYPTIAN_ARABIC",
    
    /**
     * value: ENGLISH_UK
     * @const
     */
    ENGLISH_UK: "ENGLISH_UK",
    
    /**
     * value: ENGLISH_US
     * @const
     */
    ENGLISH_US: "ENGLISH_US",
    
    /**
     * value: ESTONIAN
     * @const
     */
    ESTONIAN: "ESTONIAN",
    
    /**
     * value: FINNISH
     * @const
     */
    FINNISH: "FINNISH",
    
    /**
     * value: FRENCH
     * @const
     */
    FRENCH: "FRENCH",
    
    /**
     * value: GERMAN
     * @const
     */
    GERMAN: "GERMAN",
    
    /**
     * value: GREEK
     * @const
     */
    GREEK: "GREEK",
    
    /**
     * value: HAUSA
     * @const
     */
    HAUSA: "HAUSA",
    
    /**
     * value: HEBREW
     * @const
     */
    HEBREW: "HEBREW",
    
    /**
     * value: HINDI
     * @const
     */
    HINDI: "HINDI",
    
    /**
     * value: HUNGARIAN
     * @const
     */
    HUNGARIAN: "HUNGARIAN",
    
    /**
     * value: INDONESIAN
     * @const
     */
    INDONESIAN: "INDONESIAN",
    
    /**
     * value: ITALIAN
     * @const
     */
    ITALIAN: "ITALIAN",
    
    /**
     * value: JAPANESE
     * @const
     */
    JAPANESE: "JAPANESE",
    
    /**
     * value: JAVANESE
     * @const
     */
    JAVANESE: "JAVANESE",
    
    /**
     * value: KOREAN
     * @const
     */
    KOREAN: "KOREAN",
    
    /**
     * value: LATVIAN
     * @const
     */
    LATVIAN: "LATVIAN",
    
    /**
     * value: LITHUANIAN
     * @const
     */
    LITHUANIAN: "LITHUANIAN",
    
    /**
     * value: NORWEGIAN
     * @const
     */
    NORWEGIAN: "NORWEGIAN",
    
    /**
     * value: PERSIAN
     * @const
     */
    PERSIAN: "PERSIAN",
    
    /**
     * value: POLISH
     * @const
     */
    POLISH: "POLISH",
    
    /**
     * value: PORTUGUESE
     * @const
     */
    PORTUGUESE: "PORTUGUESE",
    
    /**
     * value: ROMANIAN
     * @const
     */
    ROMANIAN: "ROMANIAN",
    
    /**
     * value: RUSSIAN
     * @const
     */
    RUSSIAN: "RUSSIAN",
    
    /**
     * value: SERBIAN
     * @const
     */
    SERBIAN: "SERBIAN",
    
    /**
     * value: SLOVAK
     * @const
     */
    SLOVAK: "SLOVAK",
    
    /**
     * value: SLOVENIAN
     * @const
     */
    SLOVENIAN: "SLOVENIAN",
    
    /**
     * value: SPANISH
     * @const
     */
    SPANISH: "SPANISH",
    
    /**
     * value: STANDARD_ARABIC
     * @const
     */
    STANDARD_ARABIC: "STANDARD_ARABIC",
    
    /**
     * value: SWAHILI
     * @const
     */
    SWAHILI: "SWAHILI",
    
    /**
     * value: SWEDISH
     * @const
     */
    SWEDISH: "SWEDISH",
    
    /**
     * value: THAI
     * @const
     */
    THAI: "THAI",
    
    /**
     * value: TURKISH
     * @const
     */
    TURKISH: "TURKISH",
    
    /**
     * value: UKRAINIAN
     * @const
     */
    UKRAINIAN: "UKRAINIAN",
    
    /**
     * value: VIETNAMESE
     * @const
     */
    VIETNAMESE: "VIETNAMESE",
    
    /**
     * value: ZULU
     * @const
     */
    ZULU: "ZULU"
  };
  /**
   * Allowed values for the <code>nonRecoverableProcessingErrors</code> property.
   * @enum {String}
   * @readonly
   */
  exports.NonRecoverableProcessingErrorsEnum = { 
    /**
     * value: IMAGE_FILE_BROKEN
     * @const
     */
    IMAGE_FILE_BROKEN: "IMAGE_FILE_BROKEN",
    
    /**
     * value: IMAGE_PROCESSING_FAIL
     * @const
     */
    IMAGE_PROCESSING_FAIL: "IMAGE_PROCESSING_FAIL",
    
    /**
     * value: PDF_FILE_BROKEN
     * @const
     */
    PDF_FILE_BROKEN: "PDF_FILE_BROKEN",
    
    /**
     * value: PDF_PROCESSING_FAIL
     * @const
     */
    PDF_PROCESSING_FAIL: "PDF_PROCESSING_FAIL",
    
    /**
     * value: PDF_FILE_ENCRYPTED
     * @const
     */
    PDF_FILE_ENCRYPTED: "PDF_FILE_ENCRYPTED",
    
    /**
     * value: PDF_PREVIEW_PROCESSING_FAIL
     * @const
     */
    PDF_PREVIEW_PROCESSING_FAIL: "PDF_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: PDF_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    PDF_PREVIEW_PROCESSING_TIMEOUT: "PDF_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: PPT_FILE_BROKEN
     * @const
     */
    PPT_FILE_BROKEN: "PPT_FILE_BROKEN",
    
    /**
     * value: PPT_PROCESSING_FAIL
     * @const
     */
    PPT_PROCESSING_FAIL: "PPT_PROCESSING_FAIL",
    
    /**
     * value: PPT_PREVIEW_PROCESSING_FAIL
     * @const
     */
    PPT_PREVIEW_PROCESSING_FAIL: "PPT_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: PPT_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    PPT_PREVIEW_PROCESSING_TIMEOUT: "PPT_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: NB_FILE_BROKEN
     * @const
     */
    NB_FILE_BROKEN: "NB_FILE_BROKEN",
    
    /**
     * value: NB_PAGE_BROKEN
     * @const
     */
    NB_PAGE_BROKEN: "NB_PAGE_BROKEN",
    
    /**
     * value: NB_FILE_STORE_FAIL
     * @const
     */
    NB_FILE_STORE_FAIL: "NB_FILE_STORE_FAIL",
    
    /**
     * value: NB_PREVIEW_STORE_FAIL
     * @const
     */
    NB_PREVIEW_STORE_FAIL: "NB_PREVIEW_STORE_FAIL",
    
    /**
     * value: NB_RESOURCE_STORE_FAIL
     * @const
     */
    NB_RESOURCE_STORE_FAIL: "NB_RESOURCE_STORE_FAIL",
    
    /**
     * value: NB_FLASH_CONTENT
     * @const
     */
    NB_FLASH_CONTENT: "NB_FLASH_CONTENT",
    
    /**
     * value: NB_UNSUPPORTED_ANNOTATION
     * @const
     */
    NB_UNSUPPORTED_ANNOTATION: "NB_UNSUPPORTED_ANNOTATION",
    
    /**
     * value: NB_PREVIEW_PROCESSING_FAIL
     * @const
     */
    NB_PREVIEW_PROCESSING_FAIL: "NB_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: NB_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    NB_PREVIEW_PROCESSING_TIMEOUT: "NB_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: NB_PREVIEW_EMPTY_RESULT
     * @const
     */
    NB_PREVIEW_EMPTY_RESULT: "NB_PREVIEW_EMPTY_RESULT",
    
    /**
     * value: NB_PAGE_SVG_TILE_EXTRACTION_FAIL
     * @const
     */
    NB_PAGE_SVG_TILE_EXTRACTION_FAIL: "NB_PAGE_SVG_TILE_EXTRACTION_FAIL",
    
    /**
     * value: NB_FILE_SIZE_LIMIT
     * @const
     */
    NB_FILE_SIZE_LIMIT: "NB_FILE_SIZE_LIMIT",
    
    /**
     * value: TXT_FILE_PROCESSING_FAIL
     * @const
     */
    TXT_FILE_PROCESSING_FAIL: "TXT_FILE_PROCESSING_FAIL",
    
    /**
     * value: LPP_FILE_SIZE_LIMIT
     * @const
     */
    LPP_FILE_SIZE_LIMIT: "LPP_FILE_SIZE_LIMIT",
    
    /**
     * value: EXCEPTION
     * @const
     */
    EXCEPTION: "EXCEPTION",
    
    /**
     * value: OTHER
     * @const
     */
    OTHER: "OTHER"
  };
  /**
   * Allowed values for the <code>recoverableProcessingErrors</code> property.
   * @enum {String}
   * @readonly
   */
  exports.RecoverableProcessingErrorsEnum = { 
    /**
     * value: IMAGE_FILE_BROKEN
     * @const
     */
    IMAGE_FILE_BROKEN: "IMAGE_FILE_BROKEN",
    
    /**
     * value: IMAGE_PROCESSING_FAIL
     * @const
     */
    IMAGE_PROCESSING_FAIL: "IMAGE_PROCESSING_FAIL",
    
    /**
     * value: PDF_FILE_BROKEN
     * @const
     */
    PDF_FILE_BROKEN: "PDF_FILE_BROKEN",
    
    /**
     * value: PDF_PROCESSING_FAIL
     * @const
     */
    PDF_PROCESSING_FAIL: "PDF_PROCESSING_FAIL",
    
    /**
     * value: PDF_FILE_ENCRYPTED
     * @const
     */
    PDF_FILE_ENCRYPTED: "PDF_FILE_ENCRYPTED",
    
    /**
     * value: PDF_PREVIEW_PROCESSING_FAIL
     * @const
     */
    PDF_PREVIEW_PROCESSING_FAIL: "PDF_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: PDF_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    PDF_PREVIEW_PROCESSING_TIMEOUT: "PDF_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: PPT_FILE_BROKEN
     * @const
     */
    PPT_FILE_BROKEN: "PPT_FILE_BROKEN",
    
    /**
     * value: PPT_PROCESSING_FAIL
     * @const
     */
    PPT_PROCESSING_FAIL: "PPT_PROCESSING_FAIL",
    
    /**
     * value: PPT_PREVIEW_PROCESSING_FAIL
     * @const
     */
    PPT_PREVIEW_PROCESSING_FAIL: "PPT_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: PPT_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    PPT_PREVIEW_PROCESSING_TIMEOUT: "PPT_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: NB_FILE_BROKEN
     * @const
     */
    NB_FILE_BROKEN: "NB_FILE_BROKEN",
    
    /**
     * value: NB_PAGE_BROKEN
     * @const
     */
    NB_PAGE_BROKEN: "NB_PAGE_BROKEN",
    
    /**
     * value: NB_FILE_STORE_FAIL
     * @const
     */
    NB_FILE_STORE_FAIL: "NB_FILE_STORE_FAIL",
    
    /**
     * value: NB_PREVIEW_STORE_FAIL
     * @const
     */
    NB_PREVIEW_STORE_FAIL: "NB_PREVIEW_STORE_FAIL",
    
    /**
     * value: NB_RESOURCE_STORE_FAIL
     * @const
     */
    NB_RESOURCE_STORE_FAIL: "NB_RESOURCE_STORE_FAIL",
    
    /**
     * value: NB_FLASH_CONTENT
     * @const
     */
    NB_FLASH_CONTENT: "NB_FLASH_CONTENT",
    
    /**
     * value: NB_UNSUPPORTED_ANNOTATION
     * @const
     */
    NB_UNSUPPORTED_ANNOTATION: "NB_UNSUPPORTED_ANNOTATION",
    
    /**
     * value: NB_PREVIEW_PROCESSING_FAIL
     * @const
     */
    NB_PREVIEW_PROCESSING_FAIL: "NB_PREVIEW_PROCESSING_FAIL",
    
    /**
     * value: NB_PREVIEW_PROCESSING_TIMEOUT
     * @const
     */
    NB_PREVIEW_PROCESSING_TIMEOUT: "NB_PREVIEW_PROCESSING_TIMEOUT",
    
    /**
     * value: NB_PREVIEW_EMPTY_RESULT
     * @const
     */
    NB_PREVIEW_EMPTY_RESULT: "NB_PREVIEW_EMPTY_RESULT",
    
    /**
     * value: NB_PAGE_SVG_TILE_EXTRACTION_FAIL
     * @const
     */
    NB_PAGE_SVG_TILE_EXTRACTION_FAIL: "NB_PAGE_SVG_TILE_EXTRACTION_FAIL",
    
    /**
     * value: NB_FILE_SIZE_LIMIT
     * @const
     */
    NB_FILE_SIZE_LIMIT: "NB_FILE_SIZE_LIMIT",
    
    /**
     * value: TXT_FILE_PROCESSING_FAIL
     * @const
     */
    TXT_FILE_PROCESSING_FAIL: "TXT_FILE_PROCESSING_FAIL",
    
    /**
     * value: LPP_FILE_SIZE_LIMIT
     * @const
     */
    LPP_FILE_SIZE_LIMIT: "LPP_FILE_SIZE_LIMIT",
    
    /**
     * value: EXCEPTION
     * @const
     */
    EXCEPTION: "EXCEPTION",
    
    /**
     * value: OTHER
     * @const
     */
    OTHER: "OTHER"
  };  /**
   * Allowed values for the <code>resourceType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ResourceTypeEnum = { 
    /**
     * value: IMAGE
     * @const
     */
    IMAGE: "IMAGE",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: POWERPOINT
     * @const
     */
    POWERPOINT: "POWERPOINT",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: PAGE_SVG
     * @const
     */
    PAGE_SVG: "PAGE_SVG",
    
    /**
     * value: XML
     * @const
     */
    XML: "XML",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: GALLERY
     * @const
     */
    GALLERY: "GALLERY",
    
    /**
     * value: PUBLISHER
     * @const
     */
    PUBLISHER: "PUBLISHER",
    
    /**
     * value: TEXT
     * @const
     */
    TEXT: "TEXT",
    
    /**
     * value: ZIP
     * @const
     */
    ZIP: "ZIP",
    
    /**
     * value: CARTRIDGE
     * @const
     */
    CARTRIDGE: "CARTRIDGE",
    
    /**
     * value: AMP_WORKSPACE
     * @const
     */
    AMP_WORKSPACE: "AMP_WORKSPACE",
    
    /**
     * value: WORKSPACE
     * @const
     */
    WORKSPACE: "WORKSPACE",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS",
    
    /**
     * value: WORKSPACE_HOLDER
     * @const
     */
    WORKSPACE_HOLDER: "WORKSPACE_HOLDER",
    
    /**
     * value: WIDGET
     * @const
     */
    WIDGET: "WIDGET",
    
    /**
     * value: WIDGET_PACKAGE
     * @const
     */
    WIDGET_PACKAGE: "WIDGET_PACKAGE",
    
    /**
     * value: UNDEFINED
     * @const
     */
    UNDEFINED: "UNDEFINED"
  };  /**
   * Allowed values for the <code>sso</code> property.
   * @enum {String}
   * @readonly
   */
  exports.SsoEnum = { 
    /**
     * value: LTI
     * @const
     */
    LTI: "LTI",
    
    /**
     * value: GOOGLE_OAUTH
     * @const
     */
    GOOGLE_OAUTH: "GOOGLE_OAUTH",
    
    /**
     * value: OPEN
     * @const
     */
    OPEN: "OPEN",
    
    /**
     * value: NONE
     * @const
     */
    NONE: "NONE"
  };

  return exports;
}));
